export default ({ service, request, serviceForMock, requestForMock, mock, faker, tools }) => ({
  scmInfoListApi (data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/list',
      method: 'post',
      data
    })
  },
  scmInfoDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/detail',
      method: 'post',
      data
    })
  },
  scmInfoSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/save',
      method: 'post',
      data
    })
  },
  scmInfoUpdateStatusApi (data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/updateStatus',
      method: 'post',
      data
    })
  }
})
